(function () {
  var DEFAULT_CUTOFF_HOUR = 14;             // besteld voor 15:00 = eerstvolgende dag
  var ALLOWED_WEEKDAYS = [2, 3, 4, 5, 6];   // di t/m za (0=zo ... 6=za)

  function getAmsterdamNow() {
    var now = new Date();
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
    })
      .formatToParts(now)
      .reduce(function (acc, part) {
        acc[part.type] = part.value;
        return acc;
      }, {});

    return {
      date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day))),
      hour: parseInt(parts.hour, 10) % 24,
    };
  }

  function formatDay(day) {
    return new Intl.DateTimeFormat('nl-NL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC',
    }).format(day);
  }

  function buildAvailableDays(cutoffHour) {
    var now = getAmsterdamNow();
    var start = new Date(now.date);
    // Altijd minimaal 1 dag vooruit: vandaag is nooit een geldige leverdag.
    start.setUTCDate(start.getUTCDate() + 1);
    if (now.hour >= cutoffHour) {
      // Na de cutoff besteld: nog een dag extra.
      start.setUTCDate(start.getUTCDate() + 1);
    }

    var days = [];
    var cursor = new Date(start);
    var checked = 0;
    while (days.length < 10 && checked < 30) {
      if (ALLOWED_WEEKDAYS.indexOf(cursor.getUTCDay()) !== -1) {
        days.push(new Date(cursor));
      }
      cursor.setUTCDate(cursor.getUTCDate() + 1);
      checked += 1;
    }
    return days;
  }

  function populateSelect(select, cutoffHour) {
    // Altijd opnieuw opbouwen: de beschikbare dagen hangen af van het huidige
    // moment (cutoff-tijd), dus een eerder gevulde lijst kan verouderd zijn
    // als de pagina open blijft staan over het cutoff-uur heen.
    var previousValue = select.value;
    select.innerHTML = '';

    buildAvailableDays(cutoffHour).forEach(function (day) {
      var option = document.createElement('option');
      option.value = day.toISOString().slice(0, 10);
      option.textContent = formatDay(day);
      select.appendChild(option);
    });

    // Selectie herstellen als de eerder gekozen dag nog steeds geldig is,
    // anders gewoon niets voorgeselecteerd laten (eerste optie is default).
    if (previousValue) {
      var stillValid = Array.prototype.some.call(select.options, function (opt) {
        return opt.value === previousValue;
      });
      if (stillValid) select.value = previousValue;
    }
  }

  function toDDMMYYYY(isoDate) {
    // isoDate is 'YYYY-MM-DD'
    var parts = isoDate.split('-');
    return parts[2] + '-' + parts[1] + '-' + parts[0];
  }

  function saveChoice(select, statusEl, confirmBtn) {
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption || !selectedOption.value) return;

    var chosenValue = toDDMMYYYY(selectedOption.value);

    if (confirmBtn) confirmBtn.setAttribute('aria-busy', 'true');
    if (statusEl) statusEl.textContent = 'Opslaan...';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'gewenste_leverdag': chosenValue } }),
    })
      .then(function (response) { return response.json(); })
      .catch(function () {
        if (statusEl) statusEl.textContent = 'Opslaan mislukt, probeer opnieuw.';
      })
      .finally(function () {
        if (confirmBtn) confirmBtn.removeAttribute('aria-busy');
      });
  }

  function isSaturdayOption(option) {
    if (!option || !option.value) return false;
    // value is YYYY-MM-DD (UTC) — parse als UTC-datum en check weekday
    var parts = option.value.split('-');
    var d = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])));
    return d.getUTCDay() === 6; // 6 = zaterdag
  }

  // Selectors afgestemd op de .cs-delivery-day HTML-markup
  var WRAPPER_SELECTOR = '.cs-delivery-day';
  var SELECT_SELECTOR = '.cs-delivery-day__select';
  var STATUS_SELECTOR = '.cs-delivery-day__status, [id$="delivery-day-status"]';
  var CONFIRM_SELECTOR = '[data-delivery-day-confirm]'; // optioneel, hoeft niet aanwezig te zijn
  var TOGGLE_SELECTOR = '.cs-delivery-day__toggle, [id$="delivery-day-toggle"]';
  var SATURDAY_NOTE_SELECTOR = '.cs-delivery-day__saturday-note, [id$="delivery-day-saturday-note"]';

  function initWidget(el) {
    if (el.dataset.deliveryDayInitialized) return;

    var select = el.querySelector(SELECT_SELECTOR) || el.querySelector('select');
    if (!select) return;

    var statusEl = el.querySelector(STATUS_SELECTOR);
    var confirmBtn = el.querySelector(CONFIRM_SELECTOR);
    var toggle = el.querySelector(TOGGLE_SELECTOR);
    var saturdayNote = el.querySelector(SATURDAY_NOTE_SELECTOR);
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) cutoffHour = DEFAULT_CUTOFF_HOUR;

    populateSelect(select, cutoffHour);
    el.dataset.deliveryDayInitialized = 'true';

    function syncSaturdayNote() {
      if (!saturdayNote) return;
      var selectedOption = select.options[select.selectedIndex];
      saturdayNote.hidden = !isSaturdayOption(selectedOption);
    }

    select.addEventListener('change', syncSaturdayNote);
    syncSaturdayNote();

    // Checkbox-gate: dropdown pas tonen/inschakelen na aanvinken
    if (toggle) {
      var wrap = select.closest('.cs-delivery-day__select-wrap') || select;

      function syncGate() {
        var isChecked = toggle.checked;
        select.disabled = !isChecked;
        wrap.hidden = !isChecked;
        wrap.classList.toggle('is-visible', isChecked);

        if (!isChecked) {
          // Verwijder eerder opgeslagen leverdag als de gebruiker uitvinkt
          select.selectedIndex = -1;
          if (statusEl) statusEl.textContent = '';
          if (saturdayNote) saturdayNote.hidden = true;
        } else {
          // Lijst verversen op het moment van aanvinken: voorkomt dat een
          // pagina die over het cutoff-uur heen open bleef staan een
          // inmiddels ongeldige dag (bijv. "morgen") laat kiezen.
          populateSelect(select, cutoffHour);
          syncSaturdayNote();
        }
      }

      syncGate();
      toggle.addEventListener('change', syncGate);
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        saveChoice(select, statusEl, confirmBtn);
      });
    } else {
      // Geen aparte bevestigknop in de markup: sla direct op bij wijziging
      select.addEventListener('change', function () {
        saveChoice(select, statusEl, null);
      });
    }
  }

  function initAll() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(WRAPPER_SELECTOR)) {
          initWidget(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll(WRAPPER_SELECTOR).forEach(initWidget);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();